import { Component, OnInit } from "@angular/core";
import { MatCardModule } from "@angular/material/card";

@Component({
    selector: "app-commission-policy",
    templateUrl: "./commission-policy.component.html",
    styleUrls: ["./commission-policy.component.scss"],
    imports: [
        MatCardModule,
    ]
})
export class CommissionPolicyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
